<template>
  <div
    v-if="offerApply"
    class="offer-card d-flex justify-content-between row"
    @click="offerClick"
  >
    <!-- TODO: ensure responsive -->
    <div style="width: 400px">
      <h1
        class="title cursor-pointer"
        @click="$router.push({ path: '/jobs/offer/' + offerApply.offer.id + '/' + generateSlug })"
      >
        {{ offerApply.offer.titleTitle }}
      </h1>
      <h1 class="company mb-1">
        <span v-if="offerApply.offer.companyHideName === 0">
          {{ offerApply.offer.user.company.title }}
        </span>
        <span
          v-if="offerApply.offer.companyHideName === 1"
          style="color: #666; text-transform: initial; font-size: 0.8rem;"
        >
          {{ $t('generic.hidden-company-name', 'Company name not available') }}
        </span>
      </h1>
      <h1 class="location mb-1">
        {{ offerApply.offer.locationProvince }}
      </h1>
      <div class="d-flex justify-content-between mr-5">
        <div>
          <span class="sm-text">
            <font-awesome-icon
              icon="clock"
            /> {{ offerApply.created_at }}
          </span>
        </div>
      </div>
    </div>
    <div>
      <hr style="background-color: #9a9a9a; width: 1px; height: 100%; margin: 0">
    </div>
    <div class="status">
      <div
        v-if="offerApply.status === 'Accepted' || offerApply.status === 'Rejected'"
        :class="offerApply.status === 'Accepted' ? 'accepted' : 'rejected'"
      >
        <div>
          {{
            $t(`generic.${offerApply.status.toLowerCase()}`, offerApply.status)
          }}
        </div>
        <div
          v-if="offerApply.status === 'Accepted'"
          style="font-size: 0.75rem;"
        >
          {{ $t('cards.offer-application.accepted-text', 'Company has accepted your application') }}
        </div>
        <div
          v-else
          style="font-size: 0.75rem;"
        >
          {{ $t('cards.offer-application.rejected-text', 'Company has rejected your application') }}
        </div>
      </div>
      <div v-else>
        {{ $t('generic.pending', 'Pending') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    offerApply: {
      type: Object,
      default: null
    }
  },
  computed: {
    generateSlug() {
      let slug = this.offerApply.offer.titleTitle.replace(/[^A-Z0-9]+/ig, "-").toLowerCase() +
        '/' + this.offer.locationProvince.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
      return slug;
    }
  },
  methods: {
    showCV() {
      window.open(process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH + 'uploads/cv/' + this.offerApply.cv);
    },

    offerClick() {
        if (this.$auth.user() && this.$auth.user().id === this.offerApply.user_id) {
          this.$router.push({ path: '/jobs/offer/' + this.offerApply.offer_id });
        } else {
          this.$router.push({ path: '/jobs/candidate/' + this.offerApply.id });
        }
    }
  }
}
</script>


<style scoped lang="scss">
  .offer-card {
    background: white;
    padding: 25px;
    margin-bottom: 1rem;
    cursor: pointer;
    transition: 0.2s ease;

    &:hover {
      box-shadow: 3px 3px 20px 0px rgba(210,210,210,1);
    }
  }

  h1.title {
    color: #999;
    font-size: 1rem !important;
    margin-bottom: 0;
  }

  h1.company {
    color: #009090;
    font-size: 0.9rem !important;
    text-transform: uppercase;
  }

  h1.location {
    font-size: 0.8rem !important;
    font-weight: 400 !important;
    color: #9a9a9a;
  }

  .sm-text {
    font-size: 0.8rem;
    color: #666;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .status {
    margin: auto 15px auto 0;
    width: 200px;

    .accepted {
      color: green;
    }

    .rejected {
      color: red;
    }
  }
</style>
